export default function ReviewsBlock() {
  return (
    <div className="text-center py-10">
      <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200/70">
        <i className="ri-chat-quote-line text-foreground-400 text-3xl"></i>
      </div>
      <p className="text-foreground-500 text-base italic">
        Nos premiers avis clients arrivent bientôt
      </p>
    </div>
  );
}